/** @file Emits a line segment of constant pixel width as a quad (WebGL lineWidth is capped at 1). */
import { trig } from '@pose2d/math/trig';
import type { Sink } from './createSink';
import { emitQuad } from './emitQuad';

const xy = new Float64Array(8);

/** `seg` = [x0, y0, x1, y1] in pixels; zero-length or non-finite segments draw nothing. */
export function emitLine(sink: Sink, seg: ArrayLike<number>, width: number, light: number): void {
  const x0 = seg[0] ?? NaN, y0 = seg[1] ?? NaN, x1 = seg[2] ?? NaN, y1 = seg[3] ?? NaN;
  const len = trig.hypot(x1 - x0, y1 - y0);
  if (!(len > 1e-9) || !Number.isFinite(len)) return;
  const nx = (-(y1 - y0) / len) * (width / 2), ny = ((x1 - x0) / len) * (width / 2);
  xy[0] = x0 + nx; xy[1] = y0 + ny;
  xy[2] = x1 + nx; xy[3] = y1 + ny;
  xy[4] = x1 - nx; xy[5] = y1 - ny;
  xy[6] = x0 - nx; xy[7] = y0 - ny;
  emitQuad(sink, xy, light);
}
